<template>
	<div class="change-account">
		<button @click="onChangeAccountClick" class="btn btn-small btn-round" v-if="hasMoreAccounts">{{ $t('base.account.change_account') }}</button>
		<modal-box v-if="hasMoreAccounts && modalBox.open" @close="onModalBoxClose" :header="$t('base.account.change_account')">
			<input-radio-v2 v-model="selectedAccount" :options="options" name="account_selected" :placeholder="$t('base.account.accounts')" rules="required"/>
		</modal-box>
	</div>
</template>

<script>
export default {
	data () {
		return {
			modalBox: {
				open: false
			}
		}
	},
	computed: {
		hasMoreAccounts () {
			return this.accounts.data.length > 1
		},
		accounts () {
			return this.$store.state.accounts
		},
		options () {
			const options = []
			if (this.accounts.data.length) {
				this.accounts.data.forEach(account => {
					options.push({ value: account.uid, text: account.name })
				})
			}
			return options
		},
		selectedAccount: {
			get () {
				return this.$store.state.user.selectedAccount
			},
			set (newVal) {
				this.$store.dispatch('setUserSelectedAccount', newVal)
				this.$router.push({ name: 'Dashboard', params: { user_uid: newVal } })
				this.modalBox.open = false
			}
		}
	},
	methods: {
		onChangeAccountClick () {
			this.modalBox.open = true
		},
		onModalBoxClose () {
			this.modalBox.open = false
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/account/ChangeAccount.vue